<template>
	<div class="myCenter">
		<div class="myCenterCon">
			<div class="info" v-if="info">
				<div class="head">
					<div>
						我的名片
					</div>
					<i class="el-icon-edit-outline" style="font-size: 24px;" @click="edit()"></i>
				</div>
				<div class="center">
					<div class="left">
						<div class="avatarCon">
							<el-image :src="info.en_avatar" fit="cover" class="photo"></el-image>
						</div>
						<div class="nameSt">
							<div class="name">
								{{info.en_user_name}} <span>{{info.en_job}}</span>
							</div>
							<div class="standing">
								{{info.company.company_name}}
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="statusList">
				<div class="numbox">
					<div class="menu">
						<div class="text">发布职位数：</div>
						<div class="num">{{job_create_limit}}</div>
						<el-button type="text" class="icon" size="medium" v-if="info.en_account_type==2" @click="openPopup(4)">补充职位</el-button>
					</div>
					<div class="menu">
						<div class="text">发布政策数：</div>
						<div class="num">{{policy_release_limit}}</div>
						<el-button type="text" class="icon" size="medium" v-if="info.en_account_type==2" @click="openPopup(2)">补充政策</el-button>
					</div>
					<div class="menu">
						<div class="text">职位刷新次数：</div>
						<div class="num">{{job_refresh_limit}}</div>
						<el-button type="text" class="icon" size="medium" v-if="info.en_account_type==2" @click="openPopup(1)">补充次数</el-button>
					</div>
					<div class="menu">
						<div class="text">公司员工人数：</div>
						<div class="num">{{employee_certification_limit}}</div>
						<el-button type="text" class="icon" size="medium" v-if="info.en_account_type==2" @click="openPopup(3)">新增人数</el-button>
					</div>
				</div>
			</div>
		
		    <div class="statusList">
				<div class="label">
					<div v-for="(item,index) of statusList" :key='index' class="li"
						:class="{active:selectStatus==item.status}" @click="changeStatus(item.status)">
						{{item.name}}
					</div>
					<div class="li" :class="{active:selectStatus==4}" @click="changeStatus(4)">公司员工</div>
					<div class="li" :class="{active:selectStatus==5}" @click="changeStatus(5)" v-if="info.en_account_type==2">
						申请加入
						<div v-if="joinPending>0" class="unreadCount"></div>
					</div>
				</div>
			</div>
			
			<div v-loading="loading" style="min-height: 400px;">
				<div v-if="list.length==0" style="height: 400px;background: #FFFF;border-radius: 16px;"><no-Data></no-Data></div>
				<curriculumVita v-if="selectStatus==1" :list='list' :type='2' @chatConfirm="chatConfirm($event,2)"></curriculumVita>
				<curriculumVita v-else-if="selectStatus==2" :list='list' :type='4' @chatConfirm="chatConfirm($event,4)"></curriculumVita>
				<template v-if="selectStatus==3">
					<div class="msglist" v-for="item in list" :key="item.id">
						<div class="titlebox">
							<div class="left">{{item.content_type}}</div>
							<div class="date">{{item.created_at}}</div>
						</div>
						<div class="content">{{item.content}}</div>
					</div>
				</template>
				<curriculumVita v-if="selectStatus==4" :list='list' :type='5' :info="info" @staffConfirm="changeStatus(4)"></curriculumVita>
				<curriculumVita v-if="selectStatus==5" :list='list' :type='5' :join="1" :info="info" @applyConfirm="changeStatus(5)"></curriculumVita>
			</div>
			
			
			<div v-if="total>limit" class="page">
				<el-pagination background :page-size="limit" layout="prev, pager, next" :total="total"
					@current-change='changePage'>
				</el-pagination>
			</div>
		</div>
	
		<el-dialog
			title="发起沟通"
			:visible.sync="chatShow"
			width="400px">
			<div>
				<el-form label-width="70px">
					<el-form-item label="沟通职位">
						<el-select style="width: 100%;" v-model="position_id"  placeholder="请选择沟通的职位">
						    <el-option v-for="item in positionList" :key="item.id" :label="item.position_name" :value="item.id" />
						</el-select>
					</el-form-item>
				</el-form>
				<div style="text-align: center;margin-top: 28px;">
					<el-button @click="chatShow = false">取 消</el-button>
					<el-button type="primary" @click="toChat()">确定</el-button>
				</div>
			</div>
		</el-dialog>
		
		<el-dialog
			title="补充用量"
			:visible.sync="popupShow"
			append-to-body
			:close-on-click-modal="false"
			width="400px">
			<div class="popupBox" v-loading="popupLoading">
				<div class="titlebox">
					补充
					<span v-if="popupType==1">1次 职位刷新次数</span>
					<span v-if="popupType==2">1个 政策发布数</span>
					<span v-if="popupType==3">1个 认证员工数</span>
					<span v-if="popupType==4">1个 职位发布数</span>
					将消耗
					<span v-if="popupType==1">{{job_refresh_price}}</span>
					<span v-if="popupType==2">{{policy_price}}</span>
					<span v-if="popupType==3">{{employee_price}}</span>
					<span v-if="popupType==4">{{job_price}}</span>
					准币。
				</div>
				<div class="label">补充数量</div>
				<el-input size="small" type="number" placeholder="请输入补充数量" v-model="count">
				    <template slot="append">{{popupType==1?'次':popupType==3?'人':'个'}}</template>
				</el-input>
				<div style="text-align: center;margin-top: 28px;">
					<el-button @click="popupShow = false">取 消</el-button>
					<el-button type="primary" @click="confirmApply()">确定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import curriculumVita from '@/components/curriculumVita.vue'
	import { mapState } from 'vuex';
	export default {
		name:'myCenter',
		components:{ curriculumVita },
		computed: {
		    ...mapState(['joinPending']),
		},
		data() {
			return {
				statusList: [
					{ name: '沟通过', status: 1 },
					{ name: '收藏', status: 2 },
					{ name: '系统消息', status: 3 },
				],	
				selectStatus:1,
				loading:false,
				info:'',
				page: 1,
				total: 0,
				list: [],
				limit:10,
				chatShow:false,
				user_im_account:'',
				position_id:'',
				positionList:[],
				job_create_limit:'0/0',
				job_price:0,
				policy_release_limit:'0/0',
				policy_price:0,
				job_refresh_limit:'0/0',
				job_refresh_price:0,
				employee_certification_limit:'0/0',
				employee_price:0,
				popupType:'',
				count:1,
				popupShow:false,
				popupLoading:false,
			}
		},
		created() {
			this.getInfo()
			this.getList()
			this.getMyPosition()
			this.getCompanyLimit()
		},
		methods: {
			openPopup(type){
				if(this.info.en_account_type!=2) return this.$eltips('仅企业管理员可操作','error'); 
				this.popupType = type
				this.count = 1
				this.popupShow = true
			},
			confirmApply(){
				if(this.info.en_account_type!=2) return this.$eltips('仅企业管理员可操作','error'); 
				if(this.count<=0) return this.$eltips('请输入补充数量','error');
				this.popupLoading = true
				let data = {
					type:this.popupType,
					count:this.count
				}
				this.$axios.post('/api/client/ES/purchaseLimit',data).then(res=>{
					this.popupLoading = false
					if(res.code==200){
						this.popupShow = false
						this.$eltips(res.msg,'success')
						this.getCompanyLimit()
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			getCompanyLimit(){
				this.$axios.get('/api/client/ES/getCompanyLimit').then(res=>{
					if(res.code==200){
						this.job_create_limit = res.data.use_data.job_create_limit
						this.policy_release_limit = res.data.use_data.policy_release_limit
						this.job_refresh_limit = res.data.use_data.job_refresh_limit
						this.employee_certification_limit = res.data.use_data.employee_certification_limit
						
						this.job_price = res.data.purchaseprice_data.job_create_limit
						this.policy_price = res.data.purchaseprice_data.policy_release_limit
						this.job_refresh_price = res.data.purchaseprice_data.job_refresh_price
						this.employee_price = res.data.purchaseprice_data.employee_certification_limit
					}else{
						this.$eltips(res.msg,error)
					}
				})
			},
			async toChat(){
				if(!this.position_id) return this.$eltips('请选择沟通的职位','warning')
				await this.$store.dispatch('checkoutConversation', {
					conversationID:`C2C${this.user_im_account}`,
					position_id:this.position_id
				})
				this.$router.push({ name: 'communication'});
			},
			getMyPosition(){
				let data = {
					status:0,
					no_page:1
				}
				this.$axios.get('/api/client/ES/getPositionList',{params:data}).then(res=>{
					if(res.code==200){
						this.positionList = res.data
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			chatConfirm(e,type){
				if(type==2) this.user_im_account = e.other_user.user_im_account
				if(type==4) this.user_im_account = e.user.user_im_account
				this.chatShow = true
			},
			getInfo(){
				this.loading = true
				this.$axios.get('/api/client/User/info').then(res => {
					this.loading = false
					if (res.code == 200) {
						this.info=res.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			changeStatus(status){
				if(status==4) this.getInfo();
				this.page = 1
				this.total = 0
				this.list = []
				this.selectStatus=status
				this.getList()
			},
			getList() {
				this.loading = true
				let data = {
					page: this.page,
					limit: this.limit,
				}
				
				let url=''
				if(this.selectStatus==1) url='/api/client/ES/getEnChatLogslist';
				if(this.selectStatus==2) url='/api/client/ES/getUserCollections';
				if(this.selectStatus==3) url='/api/client/ES/messageNotice';
				if(this.selectStatus==4) url='/api/client/ES/getStaffList';
				if(this.selectStatus==5) url='/api/client/ES/getJoinAuthList';
				
				this.$axios.get(url, {
					params: data
				}).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.total = res.data.total
						this.list = res.data.data
						if(this.selectStatus==5){
							this.$store.commit('changeJoinPending', res.data.total)
						}
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			changePage(e) {
				console.log(e, '---e')
				this.page = e
				this.getList()
			},
			edit(){
				this.$router.push({ name: 'setBusiness',query:{type:2,status:1}});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.myCenter{
		position: relative;
		padding: 24px 0;
		display: flex;
		justify-content: center;
		.el-icon-edit-outline{
			cursor: pointer;
			margin-left: 8px;
			&:hover {
				color: #51A190;
			}
		}
		
		.myCenterCon{
			width: 1200px;
			margin: 0 auto;
			position: relative;
			z-index: 2;
			.page {
				display: flex;
				align-items: center;
				justify-content: center;
				margin: 48px 0 0;
			}
			
			.info{
				padding: 28px 32px;
				background-color: #FFF;
				border-radius: 12px;
				margin-bottom: 24px;
				.head{
					display: flex;
					align-items: center;
					justify-content: space-between;
					color: #181C2E;
					font-size: 22px;
					margin-bottom: 28px;
				}
			
			    .center{
					display: flex;
					align-items: center;
					.left{
						display: flex;
						align-items: center;
						flex:1;
						.avatarCon {
							width: 62px;
							height: 62px;
							position: relative;
							margin-right: 18px;
							.photo {
								width: 100%;
								height: 100%;
								border-radius: 50%;
							}
						}
						.nameSt{
							color: #181C2E;
							.name{
								font-size: 22px;
								display: flex;
								align-items: center;
								span{
									margin-left: 18px;
									font-size: 16px;
								}
							}
							.standing{
								font-size: 16px;
								margin-top: 8px;
							}
						}
					}
				
				    .right{
						font-size: 16px;
						flex: 1;
						color: #151515;
						.phone{
							margin-bottom: 18px;
						}
					}
				}
			}
		
		    .statusList{
				margin-bottom: 24px;
				display: flex;
				align-items: center;
				background-color: #FFF;
				padding: 20px 32px;
				border-radius: 16px;
				margin-bottom: 24px;
				.label {
					display: flex;
					align-items: center;
					.li {
						color: #151515;
						font-size: 18px;
						font-weight: bold;
						margin-right: 48px;
						cursor: pointer;
						position: relative;
						&:last-child{
							margin-right: 0;
						}
						&:hover {
							color: #51A190;
						}
						.unreadCount {
							width: 7px;
							height: 7px;
							background-color: #FF4444;
							border-radius: 50%;
							position: absolute;
							right: -4px;
							top: 0px;
						}
					}
				
					.active {
						color: #51A190;
						position: relative;
				
						&::after {
							content: '';
							display: block;
							width: 20px;
							height: 4px;
							background-color: #9B6CFF;
							border-radius: 16px;
							bottom: -12px;
							left: 50%;
							position: absolute;
							transform: translate(-50%, 0);
						}
					}
				}
				.numbox{
					flex: 1;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.menu{
						text-align: center;
						margin-right: 90px;
						display: flex;
						align-items: center;
						&:last-child{
							margin-right: 0;
						}
						.num{
							font-size: 16px;
							line-height: 1;
						}
						.text{
							font-size: 16px;
							line-height: 1;
						}
						.icon{
							margin-left: 8px;
						}
					}
					
				}
			}
	
			.msglist{
				padding: 20px 32px;
				background: #FFF;
				border-radius: 16px;
				margin-bottom: 18px;
				&:last-child{
					margin-bottom: 0;
				}
				.titlebox{
					display: flex;
					align-items: center;
					justify-content: space-between;
					.left{
						font-size: 16px;
						font-weight: bold;
					}
				}
				.content{
					margin-top: 18px;
					text-align: justify;
					font-size: 15px;
				}
			}
		}
	}
	
	.popupBox{
		.titlebox{
			margin-bottom: 18px;
			font-size: 16px;
			span{
				color: #51A190;
			}
		}
		.label{
			margin-bottom: 12px;
		}
	}
</style>